var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#F0EFED",
    stroke: "#F0EFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.458 15.8971C27.1365 15.012 26.3358 13.5056 26.3358 11.8857H22.9833L22.9768 25.6699C22.9182 27.2631 21.6098 28.509 20.0572 28.4455C18.5047 28.3854 17.2906 27.0427 17.3525 25.4495C17.4111 23.8964 18.6544 22.6706 20.1679 22.6706C20.4511 22.6706 20.731 22.7174 20.9979 22.8042V19.2905C20.7212 19.2504 20.4446 19.2304 20.1679 19.2271C16.7666 19.2271 14 22.0661 14 25.5564C14.0065 29.05 16.7634 31.8824 20.1712 31.8857C23.5725 31.8857 26.3391 29.0467 26.3391 25.5564V18.5691C27.6963 19.5711 29.327 20.1122 31 20.1088V16.6686C30.0952 16.672 29.2131 16.4014 28.458 15.8971Z",
    fill: "#02464F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.575d8ac6d33554c11ef983d64f63a81d.svg";
export { ForwardRef as ReactComponent };